import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import RaffleService from "service/Raffle";

export const getAllRaffles =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterCity: string = ""
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_RAFFLE_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_RAFFLE",
      searchValue: search,
    });

    try {
      const data = await RaffleService.getAllRaffles(
        page,
        search,
        limit,
        filterCity
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_RAFFLE", value: data.raffles });

      dispatch({
        type: "SET_RAFFLE_PAGE",
        totalPage: !!data.raffles.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.raffles.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_RAFFLE_FILTER_PAGE",
        filterCityPage: filterCity,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getRaffleCode =
  (cityId: string = "1") =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_RAFFLE_CODE_LOADING", value: true });

    try {
      const data = await RaffleService.getRaffleCode(cityId);

      dispatch({ type: "SET_RAFFLE_CODE_LOADING", value: false });
      dispatch({ type: "SET_WINNER", value: data.raffle_winner });
    } catch (err: any) {
      dispatch({ type: "SET_RAFFLE_CODE_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getAllRaffleCities = () => async (dispatch: Dispatch) => {
  dispatch({ type: "SET_FILTER_LOADING", value: true });

  try {
    const data = await RaffleService.getAllRaffleCities();

    dispatch({ type: "SET_FILTER_LOADING", value: false });
    dispatch({
      type: "SET_RAFFLE_CITY_FILTER",
      value: data.raffle_cities,
    });
    dispatch({
      type: "SET_RAFFLE_CITY_FILTER_ANALYTIC",
      value: data.raffle_cities,
    });
  } catch (err: any) {
    dispatch({ type: "SET_FILTER_LOADING", value: false });
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};
